/* src/app/components/home/home.component.css */
#draagconsult-foto {
  object-position: 53% 60%;
}
#kolfconsult-foto {
  object-position: 7%;
}
.background {
  width: 100%;
  height: 100%;
}
.background img {
  display: block;
  width: auto;
  height: auto;
  -o-object-fit: cover;
  object-fit: cover;
}
.background img.imagekit {
  width: 100vw;
  height: calc(100vh - 63px);
  object-position: 50% 30%;
}
.background-right img {
  -o-object-position: 70%;
  object-position: 70%;
}
.background-left img {
  -o-object-position: 30%;
  object-position: 30%;
}
.spaced {
  letter-spacing: 5px;
}
.carousel-slider,
.carousel-item {
  height: calc(100vh - 64px) !important;
  background-color: #26a69a;
}
.carousel-slider .title {
  text-shadow: 0 0 15px #000;
  font-size: 2.92rem;
  margin: 2rem 0 0.5rem 0;
}
.carousel .subtitle {
  text-shadow: 0 0 15px #000;
  margin: 7px 0;
  font-family:
    "Google Sans",
    Helvetica,
    arial,
    sans-serif;
  font-size: 1.64rem;
  margin: 0;
}
.caption {
  position: absolute;
  z-index: 100;
  color: #fff;
  bottom: 10rem;
}
@media (min-width: 993px) {
  .caption {
    top: 4rem;
    bottom: unset;
  }
}
@media (max-width: 993px) {
  img.imagekit {
    height: calc(100vh - 127px) !important;
  }
}
.caption .btn {
  margin-top: 0.5rem;
}
.caption.left-align {
  left: 4rem;
}
.caption.right-align {
  right: 4rem;
}
.caption.center-align {
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
}
.carousel-item {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.nav-next,
.nav-prev {
  position: absolute;
  top: calc(50vh - 64px);
  color: #fff;
  padding: 15px;
}
.nav-prev {
  left: 0;
}
.nav-next {
  right: 0;
}
/*# sourceMappingURL=home.component.css.map */
